import { r as registerInstance, h, H as Host, g as getElement } from './index-8f7fb048.js';

const marketTabPanelCss = ":host{display:none}:host([active]){display:block}";

const MarketTabPanel = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.active = undefined;
  }
  /**
   * Shows this tab panel
   */
  show() {
    this.active = true;
    return Promise.resolve();
  }
  /**
   * Hides this tab panel
   */
  hide() {
    this.active = false;
    return Promise.resolve();
  }
  render() {
    return (h(Host, { class: "market-tab-panel", tabindex: "0", role: "tabpanel" }, h("slot", null)));
  }
  get el() { return getElement(this); }
};
MarketTabPanel.style = marketTabPanelCss;

export { MarketTabPanel as market_tab_panel };
